import { createPortal } from 'react-dom';
import JxForm from '../../JxControls/JxForms/JxForm';
import JxTitleBar from '../../JxControls/JxTitleBar/JxTitleBar';
import JxButton from '../../JxControls/JxButtons/JxButton';
import { jxScrollbarThin } from '../../JxControls/jxScrollbarStyle';
import { TITLE_BAR_ACTIONS } from './TestDlgTitleBarActions';
import TestDlgBody from './TestDlgBody';
import { createSchema, createEmpty } from './TestDlgSchema';
import testDlgSaver from './TestDlgSaver';
import '../../JxControls/JxTheme.css';
import './TestDlg.css';

/**
 * TestDlg — floating dialog.
 * Extends JxForm: drag + bringToTop + Escape-to-close + Joi validation.
 * @param {boolean}  props.open
 * @param {function} props.onClose
 */
export default class TestDlg extends JxForm {
    constructor(props) {
        super(props);
        this.name = 'TestDlg';
        this.schema = createSchema();
        this.state = { ...this.state, inputs: createEmpty() };
    }

    // Literal, hardcoded default — no window.innerWidth centering math.
    getDefaultGeo() {
        return { top: 99, left: 821, width: 278, height: 310 };
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        if (this.props.open && !prevProps.open) {
            this.setState({ inputs: createEmpty() });
        }
    }

    get panelStyle() {
        return {
            ...super.panelStyle, // top, left, zIndex from JxFormDraggableBase
            width: this.state.geo.width,
            height: this.state.geo.height,
        };
    }

    handleClose = async (action) => {
        try {
            if (action === 0) {
                const errors = this.validate();
                if (errors !== null) {
                    this.setState({ errors });
                    return;
                }
                await testDlgSaver.save(this.state.inputs);
            }
            this.props.onClose?.();
        } catch (error) {
            this.logError('handleClose', error.message);
        }
    };

    render() {
        if (!this.props.open) return null;
        return createPortal(
            <div {...this.panelProps} style={this.panelStyle} className={`td-panel ${this.panelActiveClass}`}>
                <JxTitleBar
                    id={`${this.name}_titlebar`}
                    title="TestDlg"
                    variant="toolwindow"
                    isDraggable={true}
                    dragHandleProps={this.dragHandleProps}
                    actions={TITLE_BAR_ACTIONS(() => this.handleClose(-1))}
                />
                <div className={`td-body ${jxScrollbarThin}`}>
                    <TestDlgBody inputs={this.state.inputs} errors={this.state.errors} onChange={this.handleChange} />
                </div>
                <div className="td-footer">
                    <JxButton label="Cancel" variant="secondary" onClick={() => this.handleClose(-1)} />
                    <JxButton label="Save" variant="primary" onClick={() => this.handleClose(0)} />
                </div>
            </div>,
            document.body,
        );
    }
}
